import React, { useState } from "react";
import {
  Box,
  Flex,
  Text,
  Link,
  IconButton,
  Button,
  VStack,
  HStack,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Textarea,
  Tooltip,
} from "@chakra-ui/react";
import { MdPhone, MdEmail, MdLocationOn, MdOutlineEmail } from "react-icons/md";
import { BsGithub, BsLinkedin, BsPerson } from "react-icons/bs";
import { ChapterHeading, Reveal, glass } from "./story";

export default function Contact() {
  const [response, setResponse] = useState("");
  const [data, setData] = useState({ name: "", email: "", message: "", number: "" });

  const getData = (event) => {
    const { name, value } = event.target;
    setData({ ...data, [name]: value });
  };

  const handelSubmitForm = async (event) => {
    event.preventDefault();
    const { name, email, message, number } = data;

    if (name && email && message && number) {
      await fetch(
        "https://portfolio-b1027-default-rtdb.firebaseio.com/contactForm.json",
        {
          method: "POST",
          header: { "Content-Type": "application/json" },
          body: JSON.stringify({ name, email, message, number }),
        }
      );
      setResponse("Thanks for reaching out. I'll get back to you soon!");
      setData({ name: "", email: "", message: "", number: "" });
    } else {
      setResponse("Please fill in all the fields.");
    }
  };

  const contactItems = [
    { icon: MdPhone, label: "+91-8630580027", href: "tel:+918630580027" },
    { icon: MdEmail, label: "mukuljatav1010@gmail.com", href: "mailto:mukuljatav1010@gmail.com" },
    { icon: MdLocationOn, label: "Saharanpur, Uttar Pradesh, India", href: null },
  ];

  return (
    <Box id="Contact" py={{ base: "80px", md: "120px" }} px={{ base: "6%", md: "9%" }}>
      <ChapterHeading
        chapter="Epilogue · The story continues"
        title="Let's write the next chapter together"
        subtitle="Have a project, a role, or just an idea worth chasing? My inbox is always open."
      />

      <Flex
        maxW="1000px"
        mx="auto"
        gap={{ base: "28px", md: "40px" }}
        direction={{ base: "column", md: "row" }}
      >
        {/* contact info */}
        <Reveal dir="right" flex="1">
          <Box {...glass({ p: { base: "26px", md: "34px" } })} h="100%">
            <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="800" color="#f0f2f7">
              Take a coffee & chat with me ☕
            </Text>
            <Text mt="10px" color="#98a2b8" fontSize="sm" lineHeight="1.8">
              Thanks for reading all the way to the end. If any of it resonated,
              I'd love to hear from you.
            </Text>

            <VStack mt="26px" spacing={3} align="stretch">
              {contactItems.map((c) => (
                <Flex
                  key={c.label}
                  {...(c.href ? { as: Link, href: c.href } : {})}
                  align="center"
                  gap="12px"
                  p="12px"
                  borderRadius="12px"
                  border="1px solid rgba(255,255,255,0.06)"
                  _hover={c.href ? { borderColor: "#60A5FA", textDecoration: "none" } : {}}
                  transition="all 0.2s"
                >
                  <Flex
                    align="center"
                    justify="center"
                    w="38px"
                    h="38px"
                    borderRadius="10px"
                    bg="rgba(96,165,250,0.14)"
                    color="#60A5FA"
                    flexShrink={0}
                  >
                    <c.icon size="18px" />
                  </Flex>
                  <Text color="#c2c9d6" fontSize="sm">
                    {c.label}
                  </Text>
                </Flex>
              ))}
            </VStack>

            <HStack mt="24px" spacing={4}>
              <Tooltip label="LinkedIn" hasArrow bg="#60A5FA" color="white">
                <Link href="https://www.linkedin.com/in/mukul-jatav/" isExternal>
                  <IconButton
                    aria-label="LinkedIn"
                    variant="ghost"
                    size="lg"
                    isRound
                    color="#98a2b8"
                    _hover={{ bg: "#60A5FA", color: "white" }}
                    icon={<BsLinkedin size="24px" />}
                  />
                </Link>
              </Tooltip>
              <Tooltip label="GitHub" hasArrow bg="#60A5FA" color="white">
                <Link href="https://github.com/mukulsomukesh" isExternal>
                  <IconButton
                    aria-label="GitHub"
                    variant="ghost"
                    size="lg"
                    isRound
                    color="#98a2b8"
                    _hover={{ bg: "#60A5FA", color: "white" }}
                    icon={<BsGithub size="24px" />}
                  />
                </Link>
              </Tooltip>
            </HStack>
          </Box>
        </Reveal>

        {/* form */}
        <Reveal dir="left" flex="1">
          <Box as="form" onSubmit={handelSubmitForm} {...glass({ p: { base: "26px", md: "34px" } })}>
            <VStack spacing={4}>
              <FormControl id="name">
                <FormLabel color="#c2c9d6" fontSize="sm">Your Name</FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none" children={<BsPerson color="#7d879c" />} />
                  <Input
                    type="text"
                    color="white"
                    borderColor="rgba(255,255,255,0.12)"
                    _hover={{ borderColor: "rgba(255,255,255,0.25)" }}
                    _focus={{ borderColor: "#60A5FA", boxShadow: "0 0 0 1px #60A5FA" }}
                    value={data.name}
                    name="name"
                    onChange={getData}
                  />
                </InputGroup>
              </FormControl>

              <FormControl id="email">
                <FormLabel color="#c2c9d6" fontSize="sm">Email</FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none" children={<MdOutlineEmail color="#7d879c" />} />
                  <Input
                    type="email"
                    color="white"
                    borderColor="rgba(255,255,255,0.12)"
                    _hover={{ borderColor: "rgba(255,255,255,0.25)" }}
                    _focus={{ borderColor: "#60A5FA", boxShadow: "0 0 0 1px #60A5FA" }}
                    value={data.email}
                    name="email"
                    onChange={getData}
                  />
                </InputGroup>
              </FormControl>

              <FormControl id="number">
                <FormLabel color="#c2c9d6" fontSize="sm">Phone No.</FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none" children={<MdPhone color="#7d879c" />} />
                  <Input
                    type="number"
                    color="white"
                    borderColor="rgba(255,255,255,0.12)"
                    _hover={{ borderColor: "rgba(255,255,255,0.25)" }}
                    _focus={{ borderColor: "#60A5FA", boxShadow: "0 0 0 1px #60A5FA" }}
                    value={data.number}
                    name="number"
                    onChange={getData}
                  />
                </InputGroup>
              </FormControl>

              <FormControl id="message">
                <FormLabel color="#c2c9d6" fontSize="sm">Message</FormLabel>
                <Textarea
                  name="message"
                  onChange={getData}
                  value={data.message}
                  color="white"
                  borderColor="rgba(255,255,255,0.12)"
                  _hover={{ borderColor: "rgba(255,255,255,0.25)" }}
                  _focus={{ borderColor: "#60A5FA", boxShadow: "0 0 0 1px #60A5FA" }}
                  placeholder="Tell me about it"
                  _placeholder={{ color: "#5c6579" }}
                  rows={4}
                />
              </FormControl>

              <Button
                type="submit"
                w="full"
                bg="#60A5FA"
                color="white"
                fontWeight="700"
                _hover={{ bg: "#3B82F6", transform: "translateY(-2px)" }}
                transition="all 0.2s"
              >
                Send Message
              </Button>

              {response && (
                <Text color={response.includes("Thanks") ? "#4ade80" : "#93C5FD"} fontSize="sm" textAlign="center">
                  {response}
                </Text>
              )}
            </VStack>
          </Box>
        </Reveal>
      </Flex>

      <Text mt="70px" textAlign="center" color="#5c6579" fontSize="xs">
        Designed and built by Mukul Jatav · Crafted with React and Chakra UI
      </Text>
    </Box>
  );
}
